import { Editor } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';
import {
  ArrowDownToLine,
  ArrowLeftToLine,
  ArrowRightToLine,
  ArrowUpToLine,
  Columns2,
  Heading,
  Rows2,
  Trash2,
} from 'lucide-react';
import {
  BubbleBar,
  BubbleSep,
  BubbleIconButton,
} from './BubbleMenuPrimitives.tsx';

// "Add row above" from inside the header row would insert a plain row on top and
// push the grey header down — but the header is meant to stay the first row. So
// when the cursor sits in a header cell we insert below it instead; everywhere
// else "above" behaves normally.
const addRowAboveKeepingHeaderOnTop = (editor: Editor) => {
  const chain = editor.chain().focus();
  if (editor.isActive('tableHeader')) chain.addRowAfter();
  else chain.addRowBefore();
  chain.run();
};

const TableBubbleMenu = ({ editor }: { editor: Editor }) => (
  <BubbleMenu
    editor={editor}
    pluginKey="tableBubbleMenu"
    shouldShow={({ editor: e }) => e.isActive('table')}
    options={{ placement: 'top', offset: 8 }}
  >
    <BubbleBar>
      <BubbleIconButton
        title="Dodaj kolumnę z lewej"
        onClick={() => editor.chain().focus().addColumnBefore().run()}
      >
        <ArrowLeftToLine size={16} />
      </BubbleIconButton>
      <BubbleIconButton
        title="Dodaj kolumnę z prawej"
        onClick={() => editor.chain().focus().addColumnAfter().run()}
      >
        <ArrowRightToLine size={16} />
      </BubbleIconButton>
      <BubbleIconButton
        title="Usuń kolumnę"
        danger
        onClick={() => editor.chain().focus().deleteColumn().run()}
      >
        <Columns2 size={16} />
      </BubbleIconButton>

      <BubbleSep />

      <BubbleIconButton
        title="Dodaj wiersz wyżej"
        onClick={() => addRowAboveKeepingHeaderOnTop(editor)}
      >
        <ArrowUpToLine size={16} />
      </BubbleIconButton>
      <BubbleIconButton
        title="Dodaj wiersz niżej"
        onClick={() => editor.chain().focus().addRowAfter().run()}
      >
        <ArrowDownToLine size={16} />
      </BubbleIconButton>
      <BubbleIconButton
        title="Usuń wiersz"
        danger
        onClick={() => editor.chain().focus().deleteRow().run()}
      >
        <Rows2 size={16} />
      </BubbleIconButton>

      <BubbleSep />

      <BubbleIconButton
        title="Przełącz nagłówek wiersza"
        onClick={() => editor.chain().focus().toggleHeaderRow().run()}
      >
        <Heading size={16} />
      </BubbleIconButton>

      <BubbleSep />

      <BubbleIconButton
        title="Usuń tabelę"
        danger
        onClick={() => editor.chain().focus().deleteTable().run()}
      >
        <Trash2 size={16} />
      </BubbleIconButton>
    </BubbleBar>
  </BubbleMenu>
);

export default TableBubbleMenu;
